import { render, staticRenderFns } from "./ResultsByRaceCard.vue?vue&type=template&id=f3b82922&scoped=true&"
import script from "./ResultsByRaceCard.vue?vue&type=script&lang=js&"
export * from "./ResultsByRaceCard.vue?vue&type=script&lang=js&"
import style0 from "./ResultsByRaceCard.vue?vue&type=style&index=0&id=f3b82922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b82922",
  null
  
)

export default component.exports